/**
 * 온라인/오프라인 상태를 확인하고 모니터링하는 모듈
 */

// UI 관련 모듈
import { showToast } from './ui-manager.js';

/**
 * 현재 네트워크 상태를 확인하고 변경사항을 모니터링
 */
export const checkOnlineStatus = () => {
  const updateOnlineStatus = () => {
    const isOnline = navigator.onLine;
    
    const offlineToast = document.getElementById('offline-toast');
    
    if (!isOnline) {
      console.log('오프라인 상태가 감지되었습니다.');
      
      // 오프라인 토스트 표시
      if (offlineToast) {
        const bsToast = new bootstrap.Toast(offlineToast);
        bsToast.show();
      }
      
      // 오프라인 알림
      showToast('오프라인 모드로 전환되었습니다. 일부 기능이 제한될 수 있습니다.', 'warning');
      
      // 오프라인 클래스 추가
      document.body.classList.add('offline-mode');
      
      // 오프라인 이벤트 발생
      const offlineEvent = new CustomEvent('app:offline');
      document.dispatchEvent(offlineEvent);
    } else {
      console.log('온라인 상태로 복귀했습니다.');
      
      // 오프라인 토스트 숨기기
      if (offlineToast && bootstrap.Toast.getInstance(offlineToast)) {
        const bsToast = bootstrap.Toast.getInstance(offlineToast);
        bsToast.hide();
      }
      
      // 오프라인 클래스 제거
      document.body.classList.remove('offline-mode');
      
      // 온라인 이벤트 발생
      const onlineEvent = new CustomEvent('app:online');
      document.dispatchEvent(onlineEvent);
      
      // 온라인 복귀 알림
      showToast('온라인 상태로 복귀했습니다.', 'success');
    }
  };
  
  // 현재 상태 확인
  updateOnlineStatus();
  
  // 상태 변경 이벤트 리스너 등록
  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
  
  return updateOnlineStatus;
};

/**
 * 네트워크 요청 시 오프라인 상태 처리
 * @param {Function} onlineCallback - 온라인 상태일 때 실행할 콜백 함수
 * @param {Function} offlineCallback - 오프라인 상태일 때 실행할 콜백 함수
 */
export const handleNetworkRequest = async (onlineCallback, offlineCallback) => {
  if (navigator.onLine) {
    try {
      return await onlineCallback();
    } catch (error) {
      console.error('네트워크 요청 실패:', error);
      throw error;
    }
  } else {
    console.log('오프라인 상태에서의 요청이 감지되었습니다.');
    
    if (offlineCallback && typeof offlineCallback === 'function') {
      return offlineCallback();
    } else {
      throw new Error('오프라인 상태입니다. 나중에 다시 시도해주세요.');
    }
  }
}; 